export const NoDataMessage = () => (
  <p className="py-8 text-neutral-700">
    No data found for your selected scope and data range, please try another
    selection.
  </p>
);
